// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t8-0";
export var checkoutRateBadgeLink = "_t8-1";